import script from "./linkedProductSku.vue?vue&type=script&lang=ts&setup=true"
export * from "./linkedProductSku.vue?vue&type=script&lang=ts&setup=true"

import "./linkedProductSku.vue?vue&type=style&index=0&id=d663d190&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Client_OdpJ/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d663d190"]])

export default __exports__